<cm-base-dialog (closeDialog)="onClose()">
	<div cm-dialog-title>
		What's New
		@if (unreadCount() > 0) {
			<span class="unread-badge">{{ unreadCount() }} new</span>
		}
	</div>

	<div cm-dialog-body class="whats-new-body">
		@if (loading()) {
			<div class="flex items-center justify-center py-16">
				<mat-spinner diameter="40"></mat-spinner>
			</div>
		} @else if (!hasNotifications()) {
			<div class="empty-state">
				<div class="empty-icon">
					<mat-icon svgIcon="heroicons_outline:check-circle"></mat-icon>
				</div>
				<p class="empty-title">You're all caught up!</p>
				<p class="empty-subtitle">Check back later for updates.</p>
			</div>
		} @else {
			<!-- Notifications List -->
			<div class="notifications-list">
				@for (notification of notifications(); track notification.id; let i = $index) {
					<div class="notification-item" [class.unread]="!notification.dateRead">
						<!-- Notification Header (Accordion Toggle) -->
						<button
							type="button"
							(click)="toggleNotification(i)"
							class="notification-header"
							[class.expanded]="isNotificationExpanded(i)"
						>
							<div class="notification-meta">
								@if (!notification.dateRead) {
									<span class="unread-dot"></span>
								}
								<div class="notification-info">
									<h3 class="notification-title">{{ notification.title }}</h3>
									<span class="notification-date">{{ notification.dateCreated | luxonFormat : 'MMMM d, yyyy' }}</span>
								</div>
							</div>
							<mat-icon
								[svgIcon]="isNotificationExpanded(i) ? 'heroicons_outline:chevron-up' : 'heroicons_outline:chevron-down'"
								class="expand-icon"
							></mat-icon>
						</button>

					<!-- Notification Content - Render features with QuillJS -->
					@if (isNotificationExpanded(i) && notification.features) {
						<div class="notification-content whats-new-rendered">
							@for (feature of notification.features; track $index) {
								<div class="feature-item">
									<div class="feature-header">
										<h3 class="feature-title">{{ feature.title }}</h3>
										<div class="tier-badges">
											@for (tier of feature.tiers; track tier) {
												<span class="tier-badge tier-{{ tier.toLowerCase() }}">
													{{ tier === 'All' ? 'All Plans' : tier }}
												</span>
											}
										</div>
									</div>
									@if (feature.content) {
										<quill-view
											class="feature-content"
											[content]="feature.content"
											[format]="'object'"
											[theme]="'snow'"
											[modules]="{ toolbar: false }"
										></quill-view>
									}
								</div>
							}
						</div>
					}
					</div>
				}
			</div>
		}
	</div>

	<!-- Dialog Footer -->
	<div cm-dialog-footer>
		<button mat-flat-button [color]="'primary'" (click)="onClose()">Done</button>
	</div>
</cm-base-dialog>
